import React, { useEffect } from 'react'
import { useRef , useState} from 'react';
import emailjs from '@emailjs/browser';


const Contact = () => {
  useEffect(() => {
    window.scrollTo(900, 900);
  }, []);

  const [phoneNumber, setPhoneNumber] = useState('');
  const [validPhoneNumber, setValidPhoneNumber] = useState(true);
  const form = useRef();

  const validatePhoneNumber = (phoneNumber) => {
    // Regular expression for a simple phone number format (adjust as needed)
    const phoneRegex = /^[0-9]{10}$/; // Assuming a 10-digit phone number
    return phoneRegex.test(phoneNumber);
  };
  const handleChange = (event) => {
    const newPhoneNumber = event.target.value;
    const isValid = validatePhoneNumber(newPhoneNumber);
    setPhoneNumber(newPhoneNumber);
    setValidPhoneNumber(isValid);
  };


  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_zbyjqxa', 'template_aaudw6v', form.current, 'MqT5fCoagUJlZJna2')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
  };
  return (
    <div>
<div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div className="container py-5">
    <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{maxWidth: 600}}>
      <h5 className="fw-bold text-primary text-uppercase">Contact Us</h5>
      <h1 className="mb-0">If You Have Any Query,<br/> Feel Free To Contact Us</h1>
    </div>
    <div className="row g-5 mb-5">
      <div className="col-lg-4">
        <div className="d-flex align-items-center wow fadeIn" data-wow-delay="0.1s">
          <div className="bg-primary d-flex align-items-center justify-content-center rounded" style={{width: 60, height: 60}}>
            <i className="fa fa-phone-alt text-white" />
          </div>
          <div className="ps-4">
            <h5 className="mb-2">Call to ask any question</h5>
            <h4 className="text-primary mb-0">+91 86672 02180</h4>
          </div>
        </div>
      </div>
      <div className="col-lg-4">
        <div className="d-flex align-items-center wow fadeIn" data-wow-delay="0.4s">
          <div className="bg-primary d-flex align-items-center justify-content-center rounded" style={{width: 60, height: 60}}>
            <i className="fa fa-envelope-open text-white" />
          </div>
          <div className="ps-4">
            <h5 className="mb-2">Email to get free quote</h5>
            <h4 className="text-primary mb-0">acrosyskkdi@gmail.com</h4>
          </div>
        </div>
      </div>
      <div className="col-lg-4">
        <div className="d-flex align-items-center wow fadeIn" data-wow-delay="0.8s">
          <div className="bg-primary d-flex align-items-center justify-content-center rounded" style={{width: 60, height: 60}}>
            <i className="fa fa-map-marker-alt text-white" />
          </div>
          <div className="ps-4">
            <h5 className="mb-2">Visit our office</h5>
            <h4 className="text-primary mb-0">32 Lm Muthu Complext,100 Feet Road,Karaikudi-630001</h4>
          </div>
        </div>
      </div>
    </div>
    <div className="row g-5">
      <div className="col-lg-6 wow slideInUp" data-wow-delay="0.3s">
        <form ref={form} onSubmit={sendEmail}>
          <div className="row g-3">
            <div className="col-md-6">
              <input type="text" className="form-control border-0 bg-light px-4" name="user_name" placeholder="Your Name" style={{height: 55}} />
            </div>
            <div className="col-md-6">
              <input type="email" className="form-control border-0 bg-light px-4" name="user_email" placeholder="Your Email" style={{height: 55}} />
            </div>
            <div className="col-12">
              <input type="tell" className={`form-control border-0 bg-light px-4 ${validPhoneNumber ? '' : 'is-invalid'}`}  value={phoneNumber} onChange={handleChange} name="ph_no" placeholder="phone no:" style={{height: 55}} required />
              {!validPhoneNumber && <div className="text-danger">Invalid phone number format</div>}

            </div>
            <div c0lassName="col-12">
              <textarea className="form-control border-0 bg-light px-4 py-3" rows={4} name="message" placeholder="Message" defaultValue={""} />
            </div>
            <div className="col-12">
              <button className="btn btn-primary w-100 py-3" type="submit">Send Message</button>
            </div>
          </div>
        </form>
      </div>
      <div className="col-lg-6 wow slideInUp" data-wow-delay="0.6s">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3928.3109414342684!2d78.77542630034952!3d10.073588137986938!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b0067c79d8953e9%3A0x5d39d274299f36b8!2sAcrosys%20Technologies!5e0!3m2!1sen!2sin!4v1656597543433!5m2!1sen!2sin" width={600} height={450} style={{border: 0}} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
      </div>
    </div>
  </div>
</div>

    </div>
  )
}

export default Contact